/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Modal, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';


const ViewSalesReportModal = ({ isOpen, handleModal, modalData, modalDataQty,
    tableHeaderData, fileName, fileNameQty, title }) => {
    const handleDownload = (data, fName) => {
        if (!data.length) return;

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Create headers array from tableHeaderData
        const headers = tableHeaderData?.map(col => col.Header) || [];

        // Create data array with only the fields specified in tableHeaderData
        const worksheetData = data?.map(row => {
            const filteredRow = {};
            tableHeaderData?.forEach(col => {
                filteredRow[col.Header] = row[col.accessor];
            });
            return filteredRow;
        }) || [];

        // Convert data to worksheet format with proper headers
        const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'report');

        // Write the file
        XLSX.writeFile(wb, `${fName}.xlsx`);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={() => handleModal(true)}
            style={{ maxWidth: '800px' }}
            className="modal-dialog ltr-support"
            centered
        >
            <div className="modal__header">
                <button
                    className="lnr lnr-cross modal__close-btn"
                    aria-label="modal__close-btn"
                    type="button"
                    onClick={() => handleModal(false)}
                />
                <h4 className="text-modal  modal__title">{title || "Report"}</h4>
                <div className="ExcelTable"                   
                >
                    <div
                        disabled={!modalDataQty.length}
                        className="option table-action btn btn-sm"
                        onClick={() => handleDownload(modalDataQty, fileNameQty)}
                    >
                        Download Qty
                    </div>
                    <div
                        disabled={!modalData.length}
                        className="option table-action btn btn-sm"
                        onClick={() => handleDownload(modalData, fileName)}
                    >
                        Download
                    </div>
                </div>
            </div>
            <div className="modal__body">
                <Row>
                    <ResizableDataTable reactTableData={{ tableHeaderData }} data={modalData} />
                </Row>
            </div>
        </Modal>
    )
}

ViewSalesReportModal.propTypes = {
    handleModal: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    modalData: PropTypes.array.isRequired,
    modalDataQty: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
    fileName: PropTypes.string,
    fileNameQty: PropTypes.string,
    title: PropTypes.string,
};

ViewSalesReportModal.defaultProps = {
    fileName: "",
    fileNameQty: "",
    title: ""
}


export default ViewSalesReportModal;